<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title
          icon-color="teal"
          icon="mdi-format-list-numbered"
          title="Stok Listesi"
          desc="Stoktaki ürünleri listesi ve toplam stok adetleri"
        />
      </v-col>
      <v-col cols="3">
        <stok-navigasyon />
      </v-col>
      <v-col cols="9">
        <stok-list-card class="mb-2">
          <template #actions>İşlemler</template>
        </stok-list-card>
        <!-- <stok-list-card>
          <template #title>
            
          </template>
          <template #actions>
            <div class="d-flex justify-end">
              <v-btn rounded color="teal" dark small>Stok Detay</v-btn>
            </div>
          </template>
        </stok-list-card>-->
        <v-card class="px-3">
          <v-row>
            <v-col cols="12" lg="10" class="d-flex align-center py-2">
              <div>
                <div class="text-subtitle-2">Xiaomi Mi Vacuum Mop 1C 2 in 1 Robot Süpürge</div>
              </div>
            </v-col>
            <v-col cols="12" lg="2" class="py-2">
              <div class="d-flex justify-end">
                <v-btn rounded color="teal" dark small>
                  <v-icon class="mr-1" size="20">mdi-barcode</v-icon>Barkodlar /
                  <v-icon class="mr-1" size="16">mdi-view-list</v-icon>Stok Detay
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StokListCard from "../../../components/Modules/Stok/StokListCard.vue";
import PanelTitle from "../../../components/PanelTitle.vue";
import StokNavigasyon from "./StokNavigasyon.vue";

export default {
  components: { StokNavigasyon, PanelTitle, StokListCard },
  name: "StokListesi",
  methods: {
    urunListesiniGetir() {
      const baslangic = this.baslangic;
      const limit = this.limit;
      const kategoriListesi = this.aktifKategoriAdlari;
      const durum = this.urunFiltresi.aktifDurumFiltresi;
      this.listStatus = true;
      this.$store
        .dispatch("Urunler/UrunList/urunListesi", {
          baslangic,
          limit,
          kategoriListesi,
          durum
        })
        .then(() => {
          this.listStatus = false;
        });
      this.urunListeSayisi();
    },
    /**
     * Listelenen ürünün ürün listesi, filtrelenmiş
     * ürün listesi veya arama sonucu listesine göre
     * pagination'ını verir
     */
    urunListeSayisi() {
      const kategoriListesi = this.aktifKategoriAdlari;
      const durum = this.urunFiltresi.aktifDurumFiltresi;
      this.$store
        .dispatch("Urunler/UrunList/urunSayisi", { kategoriListesi, durum })
        .then(res => {
          this.urunSayisi = parseInt(res.data);
        });
    }
  },
  created() {
    /**
     * Ürün listesini getir
     */
    this.urunListesiniGetir();
  }
};
</script>

<style>
</style>